module.exports = __webpack_public_path__ + "fonts/Montserrat-LightItalic.0e5a40c.eot";